import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  allHeadacheOtherSigns: [],
  headacheOtherSign: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_35: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_AllHeadacheOtherSigns(state, headacheOtherSigns) {
    state.allHeadacheOtherSigns = headacheOtherSigns;
  },
  SET_HeadacheOtherSign(state, headacheOtherSign) {
    state.headacheOtherSign = headacheOtherSign;
  },
};
const actions = {
  errorHeadacheOtherSign({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllHeadacheOtherSigns({ commit, dispatch, rootState }) {
    return apiClient
      .get('/HeadacheOtherSigns/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllHeadacheOtherSigns', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHeadacheOtherSign', error);
      });
  },
  getHeadacheOtherSign({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/HeadacheOtherSigns/ById?headacheOtherSignId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_HeadacheOtherSign', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHeadacheOtherSign', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
